import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ShiftTemplate } from "@/actions/ssr/scheduling/getShiftTemplatesSSR";

interface ShiftTemplatesState {
  items: ShiftTemplate[];
}

const initialState: ShiftTemplatesState = {
  items: [],
};

const shiftTemplatesSlice = createSlice({
  name: "shiftTemplates",
  initialState,
  reducers: {
    setShiftTemplates(state, action: PayloadAction<ShiftTemplate[]>) {
      state.items = action.payload;
    },
  },
});

export const { setShiftTemplates } = shiftTemplatesSlice.actions;
export default shiftTemplatesSlice.reducer;
